// Simple usage tracking for production insights
// Tracks key user actions without collecting personal data

const ANALYTICS_ENDPOINT = process.env.REACT_APP_ANALYTICS_LAMBDA_URL;

// Temporarily disabled analytics due to CORS/auth issues
const shouldTrack = () => {
  return false; // Disabled until analytics endpoint is properly configured
};

// Simple event tracking
export const trackEvent = async (eventName, metadata = {}) => {
  if (!shouldTrack()) return;

  try {
    const eventData = {
      event: eventName,
      timestamp: new Date().toISOString(),
      sessionId: getSessionId(),
      metadata: {
        ...metadata,
        userAgent: navigator.userAgent,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        referrer: document.referrer || 'direct'
      }
    };

    // Send to analytics endpoint (fire and forget)
    // Use no-cors mode to avoid CORS issues while analytics endpoint is being configured
    fetch(ANALYTICS_ENDPOINT, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData)
    }).catch(() => {
      // Silently fail - don't impact user experience
    });
  } catch (error) {
    // Silently fail - analytics should never break the app
  }
};

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session', sessionId);
  }
  return sessionId;
};

// Track page views
export const trackPageView = (pageName) => {
  trackEvent('page_view', { page: pageName });
};

// Track user actions
export const trackUserAction = (action, details = {}) => {
  trackEvent('user_action', { action, ...details });
};

// Track feature usage
export const trackFeatureUsage = (feature, context = {}) => {
  trackEvent('feature_usage', { feature, ...context });
};

// Daily active user tracking (once per day per session)
export const trackDailyActive = () => {
  const today = new Date().toDateString();
  const lastTracked = localStorage.getItem('last_dau_tracked');
  
  if (lastTracked !== today) {
    trackEvent('daily_active_user');
    localStorage.setItem('last_dau_tracked', today);
  }
};

// Export for easy integration
export default {
  trackEvent,
  trackPageView,
  trackUserAction,
  trackFeatureUsage,
  trackDailyActive
};